<ul
    #submenu
    [ngClass]="{ arrowAtBottom: isOutsideWindowBounds$ | async }"
    [style.top.px]="topOffset$ | async"
    [style.left.px]="left()"
    class="submenu-list sidebar"
    [style.zIndex]="1002"
    (mouseenter)="onMouseEnterSubmenu()"
    (mouseleave)="onMouseLeaveSubmenu()"
>
    @for (subitem of children(); track subitem) {
        <li>
            <a [routerLink]="subitem.path" routerLinkActive="active" class="submenu-link" (click)="onSubitemClick()">
                {{ subitem.title | translate }}
            </a>
        </li>
    }
</ul>
